import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  Image,
  TypographyStylesProvider,
  Code,
  Box,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconExchange,
  IconHistory,
} from "@tabler/icons-react";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";
import SimpleImage from "../articlesHelpers/SimpleImage";

const event = {
  stamp: 1731704940626,
  raw_data: {
    id: "d6b354bfa3b9076c2d380c915f25cca901c187a0e6da28c04aaa6d2f84942bdf",
    inputs: [
      {
        is_local: false,
        transaction_id:
          "a248110e93adc8292119e4c849b42e94e0737125597d81fc1750df1a7e594206",
        transaction_vout: 1,
      },
    ],
    tokens: 200000,
    created_at: "2024-11-15T21:09:00.000Z",
    is_outgoing: false,
    transaction:
      "010000000001010642597e1adf5017fc817d59257173e0942eb449c8e4192129c8ad930e1148a20100000000ffffffff02400d030000000000225120264445bcf7548c61a0f8217cef31315f7a467c082dd0202527eb54e9d5ced0021a49551000000000225120179f4c42859fcdf41fdad8ee29a7c50240e07095bf40033b96b20ac8a113b87301405b49babfa93eeacb1cae7b89567bee6696f315df1333907b4bc39f065a29278fa34617edfbabfe1c1554a3e62d46a1d99ea00896209927642f28ee36c68c22d500000000",
    is_confirmed: false,
    output_addresses: [
      "bc1pyezyt08h2jxxrg8cy97w7vf3taayvlqg9hgzqff8ad2wn4ww6qpq4cx5lk",
      "bc1pz705cs59nlxlg876mrhznf79qfqwquy4haqqxwukkg9v3ggnhpesul50h6",
    ],
  },
};

export const PENDING_BTC_BALANCE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      When you have a pending BTC balance, it means that you have a transaction
      that is waiting to be confirmed on the blockchain.
    </p>
    <p>
      This can happen when you deposit or withdraw BTC, or when you receive a
      payment, or when a channel is in the process of opening or closing.
    </p>
    <p>
      Generally, the thing to do is wait until the funds confirm. But you can
      also take a closer look at what is going on.
    </p>

    <p>Look for the History button near the bottom of your screen:</p>

    <DocsButton
      ariaLabel="history"
      text="History"
      leftSection={<IconHistory />}
    />

    <p>You will find in that menu a record of your "On-chain transactions."</p>

    <SimpleImage
      h={400}
      src="docs_images/history-menu-on-chain-transactions.png"
    />
    <p>
      We then see some data about recent transactions, which will look like
      this:
    </p>
    <Box mb="20px">
      <JsonView
        data={event}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>
    <p>
      There is detail here that we will cover later in this documentation, but
      just for now, you can note that:
    </p>

    <ol>
      <li>
        We see a{" "}
        <Code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          transaction_id:"a248110e93adc8292119e4c849b42e94e0737125597d81fc1750df1a7e594206"
        </Code>
        . You could paste that transaction id into a block explorer like{" "}
        <Anchor href="https://blockstream.info" target="_blank">
          blockstream.info
        </Anchor>{" "}
        to see the status of that transaction.
      </li>
      <li>
        The transaction is noted as <Code> is_confirmed: false</Code>, which
        means it's not yet confirmed.
      </li>
    </ol>
  </TypographyStylesProvider>
);
